import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  fetchBlogDetails,
  fetchBlogpage,
  
  fetchContactPage,
  fetchGeneralPage,
  fetchServices,
  fetchTestimonials,
} from "../Redux/slice/homeSlice";
import { Icon } from "@iconify/react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const ContactRap = styled.div`
  background: linear-gradient(0deg, #ffffff 0%, #f6f5f2 20%);
  padding-bottom: 50px;
  .upper-p {
    padding: 5px 15px;
    width: fit-content;
    height: 31px;
    display: flex;
    border: 1px solid #0000001a;
    color: #1c4b42;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    font-size: 11px;
    font-weight: 500;
  }
  h1 {
    color: #1c4b42;
    font-size: 52px;
    line-height: 57px;
    font-weight: 400;
    max-width: 700px;
    text-align: center;
  }
  h2 {
    color: #1c4b42;
    font-size: 48px;
    line-height: 57px;
    font-weight: 400;
  }
.contact-1 p {
    font-size: 20px;
    line-height: 30px;
    color: #1c4b42;
    max-width: 535px;
    text-align: center;
}
.contact-1  {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-top: 160px;
    align-items: center;
}
.contact-2-circle {
    background: #1c4b42;
    border: #1c4b42;
    width: 60px;
    height: 60px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.contact-2-inner p {
    color: #1c4b42;
    font-size: 16px;
    font-weight: 400;
}
.contact-2-inner h5 {
    color: #000000;
    font-size: 16px;
    font-weight: 400;
    max-width: 207px;
    line-height: 22px;
}
.contact-2-inner {
    display: flex;
    flex-direction: column;
    gap: 5px;
}
.contact-2-sub {
    display: flex;
    align-items: flex-end;
    gap: 15px;
}
.contact-2 {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-top: 80px;
}
.contact-3-form p {
    font-size: 16px;
    line-height: 22px;
    color: #000000cc;
    font-weight: 400;
    max-width: 408px;
}
form input {
    border: none;
    width: 260px;
    height: 50px;
    border-radius: 9px;
    background: #ffffff;
    padding-left: 15px;
}
form textarea {
     border: none;
    width: 540px;
    height: 88px;
    border-radius: 9px;
    padding-top: 15px;
    background: #ffffff;
    padding-left: 15px;
}
label {
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.form-1 {
    display: flex;
    gap: 20px;
}
form {
    display: flex;
    flex-direction: column;
    gap: 15px;
}
form button {
    background: #1c4b42;
    width: 100px;
    height: 47px;
    border: none;
    color: #ffffff;
    font-size: 15px;
    font-weight: 500;
    border-radius: 100px;
}
.contact-3-form {
 display: flex;
 background: #F6F5F2;
 width: 640px;
 margin-right: -40px;
border-radius: 24px;
z-index: 1000;
padding: 20px;
    flex-direction: column;
    gap: 25px;
    justify-content: space-between;
}
.contact-3-sub img {
    width: 100%;
    object-fit: cover;
    height: 100%;
    border-radius: 24px;
}
.contact-3 {
    display: flex;
    margin-top: 100px;
}
.contact-3-sub {
    width: 670px;
    position: relative;
    height: 670px;
    border-radius: 24px;
}
.contact-3-circle {
    background: #B4E717;
    width: 45px;
    height: 45px;
    border-radius: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.contact-3-inner p {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
    max-width: 430px;
    line-height: 22px;
}
.contact-3-inner {
    display: flex;
    align-items: flex-end;
    gap: 20px;
    backdrop-filter: blur(40px);
    background: #FFFFFFCC;
    padding: 10px 20px;
    border-radius: 46px;
    position: absolute;
    bottom: 30px;
    left: 60px;
}
.office-1-upper h6 {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #F6F5F2;
    width: 128px;
    height: 31px;
    color: #f6f5f2;
    font-weight: 400;
    border-radius: 100px;
    font-size: 11px;
}
.office-1-upper h3 {
    color: #ffffff;
    font-weight: 500;
    font-size: 30px;
    max-width: 195px;
    line-height: 36px;
}
.office-1-middle h4 {
     color: #ffffff;
    font-weight: 500;
    font-size: 20px;
    max-width: 142px;
    line-height: 24px;
}
.office-1-middle p {
     color: #ffffff;
    font-weight: 400;
    font-size: 16px;
    max-width: 207px;
    line-height: 22px;
}
.office-1-middle, .office-1-upper {
    display: flex;
    flex-direction: column;
    gap: 15px;
}
.all-office-1-upper {
    display: flex;
    flex-direction: column;
    gap: 30px;
}
.office-1-down p {
     color: #ffffff;
    font-weight: 500;
    font-size: 14px;
}
.office-1-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    background: #B4E717;
width: 20px;
height: 20px;
}
.office-1-down {
    display: flex;
    align-items: center;
    gap: 5px;
}

.cut-color-img {
    width: 325px;
    height: 240px;
    position: absolute;
    bottom: 0px;
    right: 0px;
}
.middle-circle {
     display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    background: #1C4B42;
width: 20px;
height: 20px;
}
.middle-office {
    display: flex;
    align-items: flex-end;
    gap: 10px;
}
.office-1 {
    background: #1C4B42;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
    border-radius: 24px;
    position: relative;
    width: 390px;
    height: 432px;
}
.office-2 {
    border: 1px solid #0000001A;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
    border-radius: 24px;
    width: 390px;
    height: 432px;
    
}
.contact-4-offices {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}
.contact-4 {
        display: flex;
    flex-direction: column;
    gap: 30px;
    margin: 100px 0px;
}

.office-2-upper h3 {
    color: #1C4B42;
    font-weight: 500;
    font-size: 30px;
    max-width: 195px;
    line-height: 36px;
}
.office-2-middle h4 {
     color: #1C4B42;
    font-weight: 500;
    font-size: 20px;
    max-width: 142px;
    line-height: 24px;
}
.office-2-middle p {
     color: #000000cc;
    font-weight: 400;
    font-size: 16px;
    max-width: 207px;
    line-height: 22px;
}
.office-2-middle, .office-2-upper {
    display: flex;
    flex-direction: column;
    gap: 15px;
}
.office-2-down p {
     color: #000000cc;
    font-weight: 500;
    font-size: 14px;
}

.office-2-down {
    display: flex;
    align-items: center;
    gap: 5px;
}

  .contact-5-left {
    position: relative;
  }
  .contact-5-box {
    backdrop-filter: blur(40px);
    background: #ffffffcc;
    border-radius: 20px;
    width: 170px;
    height: 115px;
    display: flex;
    position: absolute;
    right: 20px;
    bottom: 20px;
    justify-content: center;
    align-items: center;
  }
  .contact-5-box img {
    width: 100px;
    height: 45px;
  }
  .card-4-upper h6 {
    border: 1px solid #0000001a;
    width: 143px;
    height: 31px;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1c4b42;
    font-size: 11px;
    font-weight: 500;
  }
  .card-4-upper h3 {
    max-width: 306px;
    line-height: 36px;
    font-size: 30px;
    color: #1c4b42;
    font-weight: 500;
  }
  .card-4-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .upper-4-icon {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }
  .upper-4-icon img {
    width: 20px;
    height: 20px;
  }
  .card-4-down p {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
    max-width: 356px;
    line-height: 22px;
  }
  .card-4-down {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .card-4-btn, .-btn {
    border: none;
    background: #1c4b42;
    color: #ffffff;
    width: 175px;
    border-radius: 100px;
    height: 48px;
    font-size: 15px;
    font-weight: 400;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card-4-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    background: #1c4b42;
    border-radius: 100px;
  }
  .card-4-sub {
    display: flex;
  }
  .contact-5-card {
    background: #b4e717;
    width: 420px;
    height: 550px;
    border-radius: 24px;
    display: flex;
    padding: 20px;
    flex-direction: column;
    justify-content: space-between;
  }
  .contact-5-img {
    max-width: 750px;
    height: 550px;
        border-radius: 24px;

  }
  .contact-5 {
    display: flex;
    gap: 20px;
    margin-top: 80px;
    justify-content: space-between;
  }
     @media (max-width: 1270px) {
.office-1 , .office-2 {
    width: 370px;
}

   .contact-5-img {
    max-width: 700px;
   }
}

   @media (max-width: 1200px) {

   .contact-5-img {
    max-width: 650px;
   }
   .office-1 , .office-2 {
    width: 320px;
}
}
   @media (max-width: 1150px) {
.contact-3 {
    flex-direction: column;
    gap: 30px;
}
.contact-3-sub img {
height: auto;
}
.contact-3-form {
    width: 100%;
    margin-right: 0px;
}
.contact-3-inner {
    left: 20px;
    right: 10px;
}
form input {
    width: 100%;
}
.form-1  {
    flex-direction: column;
}
form textarea {
    width: 100%;
}
   }

    @media (max-width: 1024px) {
        .contact-4-offices {
            grid-template-columns: repeat(2, 1fr);
        }
           .office-1 , .office-2 {
    width: 400px;
}
    }
 @media (max-width: 992px) { 
h1 {
    font-size: 45px;
}
.contact-3-sub {
    width: 100%;
}
           .office-1 , .office-2 {
    width: 350px;
}
h2 {
    font-size: 40px;
}
.contact-2 {
    flex-wrap: wrap;
}
.contact-5 {
    flex-direction: column;
}
  .contact-5-img {
    max-width: 100%;
    height: auto;
   }
 .contact-5-card {
        width: 100%;
   }
  
 }
   @media (max-width: 800px) { 
           .office-1 , .office-2 {
    width: 320px;
}
   }
     @media (max-width: 700px) {  
           .office-1 , .office-2 {
    width: 100%;
           }
    h1 {
    font-size: 32px;
    line-height: 40px;
}

.contact-3-sub {
    height: 500px;
}
h2 {
    font-size: 28px;
    line-height: 32px;
}

.contact-5-card {
     height: 450px;
}


.contact-4-offices {
            grid-template-columns: repeat(1, 1fr);
        }
        .contact-3-inner{ 
            border-radius: 10px;
        }
     }
  @media (max-width: 600px) { 
.contact-5-img  {
    height: 513px;
}
.contact-3-circle {
   white-space: nowrap;
   flex-shrink: 0;
}
.contact-3-sub {
    height: 500px;
}
  }
    @media (max-width: 500px) { 
.contact-5-img  {
    height: 413px;
}

.contact-3-inner {
    left: 5px;
}
.contact-3-sub {
    height: 400px;
}


.cut-color-img {
    width: 275px;
height: 220px;
}
  }

  @media (max-width: 450px) { 
.contact-3-inner {
    bottom: 50px;
    align-items: flex-start;
}
.contact-5 {
    margin-top: 20px;
}
  }
   @media (max-width: 390px) { 
.contact-3-inner {
    bottom: 70px;
}
  }
    @media (max-width: 360px) { 
.contact-3-inner {
    bottom: 110px;
}
  }

    @media (max-width: 330px) { 
.contact-3-inner {
    bottom: 130px;
}
  }
`;

const Contact = () => {
 
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { contactObject, generalObject } = useSelector((state) => state.content);

  const contactTop = contactObject?.data?.contactTop
   const contactForm = contactObject?.data?.contactForm
    const locations = contactObject?.data?.locations
     const bottomBanner = contactObject?.data?.bottomBanner
    const websetting = generalObject?.data?.websetting

const headquarters = locations?.filter(
  (item) => item.address_type.trim().toLowerCase() === "headquarters"
);

console.log(generalObject);

 const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, 0);
  }, [location.pathname]);

  useEffect(() => {
    dispatch(fetchContactPage());
  }, [dispatch]);

   useEffect(() => {
    dispatch(fetchGeneralPage());
  }, [dispatch]);

  
  return (
    <ContactRap>
        <div className="contact-1 containers">
            <h6 className="upper-p">{contactTop?.small_title}</h6>
            <h1>{contactTop?.main_title}</h1>
            <p>{contactTop?.content}</p>
        </div>
        <div className="contact-2 containers">
            {headquarters?.map((item) => (
    <div className="contact-2-sub">
                <div className="contact-2-circle">
                     <Icon
                                      width="20px"
                                      height="20px"
                                      icon="mi:location"
                                      style={{ color: "white" }}
                                    />
                </div>
                <div className="contact-2-inner">
                    <p>{item?.city}</p>
                    <h5>{item?.address}</h5>
                </div>
            </div>
            ))}
        
            <div className="contact-2-sub">
                <div className="contact-2-circle">
                     <Icon
                                      width="20px"
                                      height="20px"
                                      icon="fluent:call-12-filled"
                                      style={{ color: "white" }}
                                    />
                </div>
                <div className="contact-2-inner">
                    <p>Phone Number</p>
                    <h5>{websetting?.biz_phone}</h5>
                </div>
            </div>
            <div className="contact-2-sub">
                <div className="contact-2-circle">
                     <Icon
                                      width="20px"
                                      height="20px"
                                      icon="ic:outline-email"
                                      style={{ color: "white" }}
                                    />
                </div>
                <div className="contact-2-inner">
                    <p>Email</p>
                    <h5>{websetting?.biz_email}</h5>
                </div>
            </div>
        </div>
        <div className="contact-3 containers">
            <div className="contact-3-form">
                <h6 className="upper-p">{contactForm?.small_title}</h6>
                <h2>{contactForm?.main_title}</h2>
                <p>{contactForm?.content}</p>
                <form>
                    <div className="form-1">
                        <label>
                            Your name
                            <input type="text" 
                                    placeholder="e.g John Smith" />
                            
                        </label>
                        <label>
                            Email address
                            <input type="email" 
                                    placeholder="e.g John@gmail.com" />
                            
                        </label>
                    </div>
                     <div className="form-1">
                        <label>
                            Phone number
                            <input type="text" 
                                    placeholder="e.g +1 222 444 66" />
                            
                        </label>
                        <label>
                            Company name
                            <input type="text" 
                                    placeholder="excecor" />
                            
                        </label>
                    </div>
                    <label>
                            Message
                        <textarea placeholder="Tye here...." />
                    </label>
                    <button>Submit</button>
                </form>
            </div>
            <div className="contact-3-sub">
                 <img src={`https://backoffice.holybrookstransportation.com/${contactForm?.banner}`} alt="" />
                 <div className="contact-3-inner">
                    <div className="contact-3-circle">
                            <Icon
                                      width="14px"
                                      height="14px"
                                      icon="fluent:call-12-filled"
                                      style={{ color: "#1C4B42" }}
                                    />
                    </div>
                    <p>{contactForm?.bottom_banner_title}</p>
                 </div>
            </div>
           
        </div>
        <div className="contact-4 containers">
            <h2></h2>
            <div className="contact-4-offices">
                {headquarters?.map((item) => (
<div className="office-1">
                    <div className="all-office-1-upper">
                        <div className="office-1-upper">
                            <h6>{item?.address_type}</h6>
                            <h3>{item?.title}</h3>
                        </div>
                        <div className="office-1-middle">
                            <h4>{item?.city}</h4>
                            <p>{item?.address}</p>
                        </div>
                    </div>
                    <div className="office-1-down">
                        <p>Get diirection</p>
                        <div className="office-1-circle">
                            <Icon
                                      width="14px"
                                      height="14px"
                                      icon="mdi:arrow-top-right"
                                      style={{ color: "#1C4B42" }}
                                    />
                        </div>
                    </div>
                    <img 
                    src="/images/cut-3.png" alt=""
                    className="cut-color-img" />
                </div>
                ))}
                {locations?.filter((loc) => loc.address_type.trim().toLowerCase() !== "headquarters").map((loc) => (
                <div className="office-2">
                    <div className="all-office-1-upper">
                        <div className="office-2-upper">
                            <h6 className="upper-p">{loc?.address_type}</h6>
                            <h3>{loc?.title}</h3>
                        </div>
                        <div className="office-2-middle">
                            <h4>{loc?.city}</h4>
                            <p>{loc?.address}</p>
                            <div className="middle-office">
                                <div className="middle-circle">
                                     <Icon
                                      width="14px"
                                      height="14px"
                                      icon="fluent:call-12-filled"
                                      style={{ color: "#B4E717" }}
                                    />
                                </div>
                                <p>{loc?.phone}</p>
                            </div>
                        </div>
                    </div>
                    <div className="office-2-down">
                        <p>Get direction</p>
                        <div className="office-1-circle">
                             <Icon
                                      width="14px"
                                      height="14px"
                                      icon="mdi:arrow-top-right"
                                      style={{ color: "#1C4B42" }}
                                    />
                        </div>
                    </div>
                </div>
                ))}
            </div>
        </div>
         <div className="contact-5 containers ">
                      <div className="contact-5-left">
                        <img
                          className="contact-5-img "
                          src={`https://backoffice.holybrookstransportation.com/${bottomBanner?.banner}`}
                          alt=""
                        />
                       
                      </div>
                      <div className="contact-5-card">
                        <div className="card-4-upper">
                            <div className="upper-4-icon">
                          <h6>{bottomBanner?.small_title}</h6>
                          <img src="/images/icon-5.png" alt="" />
                          </div>
                          <h3>{bottomBanner?.main_title}</h3>
                        </div>
                        <div className="card-4-down">
                          <p>{bottomBanner?.content}</p>
                          <div className="card-4-sub">
                            <a
                              href={bottomBanner?.first_btn_link}
                              className="card-4-btn"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {bottomBanner?.first_btn_title}
                            </a>
                            <div className="card-4-circle">
                                 <Icon
                                        width="14px"
                                        height="14px"
                                        icon="mdi:arrow-top-right"
                                        style={{ color: " #b4e717" }}
                                    />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
    </ContactRap>
  );
};

export default Contact;
